import { Component } from '../helpers/helper';

export const CreatePage = Component(() => {
	return () => (
		<div class="store-page" id="create">
			<iframe frameborder="0" width="100%" height="100%" src="https://gatheract.com/docs/#/collaboration"></iframe>
		</div>
	);
});
